import { INewbuildingsRecommendations, IRecommendations } from '../../../types/newbuildingRecommendations';
import { IPromoBanner } from '../../../types/newbuildingBanners/promoBanner';
import { ICompilation } from '../../../types/newbuildingBanners/compilationBanner';
import { TBanners } from '../../../types/newbuildingBanners/banners';

interface IMergeBannersAndRecommendations {
  newbuildings: INewbuildingsRecommendations;
  banners: TBanners[];
}
type TItem = IRecommendations | IPromoBanner | ICompilation;

const BANNER_POSITIONS = [1, 6, 11, 16];

export const mergeBannersAndRecommendations = ({ newbuildings, banners }: IMergeBannersAndRecommendations): TItem[] => {
  const mergedData = [];
  const bannerPositions = BANNER_POSITIONS;
  const { recommendations } = newbuildings;
  let bannersPointer = 0;

  for (let i = 0; i < recommendations.length; i++) {
    const recommendation = recommendations[i];

    if (!bannerPositions.includes(mergedData.length)) {
      mergedData.push(recommendation);
    } else {
      const bannerData = banners[bannersPointer];
      bannersPointer++;
      if (bannerData) {
        mergedData.push(bannerData);
      }

      mergedData.push(recommendation);
    }
  }

  while (bannersPointer < banners.length) {
    const bannerData = banners[bannersPointer];
    bannersPointer++;
    if (bannerData) {
      mergedData.push(bannerData);
    }
  }

  return mergedData.slice(0, 20);
};
